import { getGeoData } from '@api/geoData';
import { useEffect, useState } from 'react';

export const useGeoData = (id: string) => {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (id) {
      getGeoData(id)
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    }

    return setData([]);
  }, [id]);

  return {
    data,
  };
};
